import BaseAccordion from 'components/Accordions/BaseAccordion';
import WeatherCardGrid from '../../../../components/WeatherCardGrid/WeatherCardGrid';
import { airQualityDetails, getAirQualityCategoryColor } from '../../config/airQuality.config';
import { getAirQualityCardKey, getAirQualityCardTitle } from '../../utils/airQuality.utils';
import { PiWavesBold } from 'react-icons/pi';

const AirQualityStationAccordion = ({ station }) => {
  return (
    <BaseAccordion
      eventKey={station.stationName}
      header={<div className="fw-semibold">{station.stationName}</div>}
    >
      <WeatherCardGrid
        loading={false}
        forecast={station.reports}
        cardDetails={airQualityDetails}
        getCardKey={getAirQualityCardKey}
        getCardTitle={getAirQualityCardTitle}
        getCardIcon={(item) => (
          <PiWavesBold size={25} color={getAirQualityCategoryColor(item?.category)} />
        )}
        emptyMessage={`No air quality forecast data available for ${station.stationName}.`}
      />
    </BaseAccordion>
  );
};

export default AirQualityStationAccordion;
